import type { FC } from 'react';
import { DateRangePicker } from './DateRangePicker';
import type { Grouping } from '../types';

interface ControlBarProps {
  range: { from: string; to: string };
  onRangeChange: (range: { from: string; to: string }) => void;
  grouping: Grouping;
  onGroupingChange: (g: Grouping) => void;
}

const GROUPINGS: { value: Grouping; label: string }[] = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
];

export const ControlBar: FC<ControlBarProps> = ({ range, onRangeChange, grouping, onGroupingChange }) => (
  <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 pt-3">
    <div className="d-flex align-items-center gap-2">
      <span className="text-muted small">Group by</span>
      <div className="btn-group btn-group-sm">
        {GROUPINGS.map((g) => (
          <button
            key={g.value}
            type="button"
            className={`btn ${grouping === g.value ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => onGroupingChange(g.value)}
          >
            {g.label}
          </button>
        ))}
      </div>
    </div>
    <DateRangePicker from={range.from} to={range.to} onChange={onRangeChange} />
  </div>
);
